const config = {};

config.webTitle = "DREAM11";
config.lang = {
  English: "en",
};

config.enumClientIds = {
  FB: 1,
  TW: 2,
  WA: 3,
};

config.LOGIN_API_URL = config.API_BASE + "Session/waf-login";
config.clientCookie = "_URC";
// config.userBackendCookie = "Quiz_007";
config.userCookie = "fihquiz_SRAW";
config.userBackendCookie = "fihquiz_008";
config.reloadAnimationDelay = 3000;
config.totalAttempts = 100;
config.platformId = 3;
config.URL_BASE = "/";
config.BASE_DOMAIN = "/";
config.ACCOUNTS_API_BASE = config.BASE_DOMAIN + "services/";

// config.BASE_DOMAIN = "/quiz/";
// config.URL_BASE = config.BASE_DOMAIN;
config.lang2D = Object.keys(config.lang).map((key) => {
  return config.lang[key];
});
config.defaultLanguage = "en";
config.CURRENT_LANGUAGE = config.defaultLanguage;
let splitUrl = window.location.href.split("?lang=");
let subURL = splitUrl && splitUrl.length > 1 ? splitUrl[1] : null;
if (subURL && subURL.length) {
  let possibleLang = subURL.split("&").filter(Boolean)[0];
  if (config.lang2D.indexOf(possibleLang) > -1) {
    config.CURRENT_LANGUAGE = possibleLang;
  } else {
    config.CURRENT_LANGUAGE = config.defaultLanguage;
  }
}

// config.COOKIE_FANTASY = "d11partner";
// config.COOKIE_FANTASY = "Quiz_SRAW";
config.enumLeaderboardTabs = {
  overall: "overall",
  daily: "daily",
};
config.ImgVersion = 3.6;
config.endGameDate = "7/17/22 11:59:00 PM";
// config.endGameDate = "2022-07-17T22:00:00Z";
config.COOKIE_FANTASY = "fihquiz_SRAW";
config.COOKIE_CSRF = "__csrf";
config.COOKIE_STRP = "COOKIE_STRP";
config.headers = { entity: "ed0t4n$3!" };
config.enumLoginCookie = {
  bothNotPresent: 1,
  fifaPresent: 2,
  fantasyPresent: 3,
  bothPresent: 4,
};

// config.FB_ID = "505670046484855";
let location = window.location.href;
config.origin = window.location.origin;
config.loginLink = "/socialapi/auth/yahoo?cbkurl=/home";
config.logoutLink = "/socialapi/auth/signout";
config.CAPTCHA_KEY = "6LcNRsQaAAAAAJqwOH5MmH2-Ul-zQnZ4afY4orv0";

// + '/socialapi/auth/yahoo?cbkurl=/home';

if (location.indexOf(".sportz.io") > -1) {
  config.BASE_DOMAIN = "/";
  config.API_BASE = config.BASE_DOMAIN;
  config.IMG_BASE = config.BASE_DOMAIN + "static-assets/quiz/build/images/";
  config.IMG_TEAM = config.IMG_BASE + "flags/{{teamId}}.png";
  config.IMG_OVERLAY_TEAM = config.IMG_BASE + "flags/overlay/{{teamId}}.png";
  config.IMG_CONTEST_LOGO = config.IMG_BASE + "contestLogos/{{imgName}}.png";
  config.DefaultFlagImagesURL = config.IMG_TEAM.replace("{TeamId}", "Default");
  config.IMG_PITCH = config.IMG_BASE + "players/onpitch/{{playerId}}.png";
  config.IMG_CARD = config.IMG_PITCH;
  config.DEFAULT_IMG_CARD = config.IMG_CARD.replace("{{playerId}}", "default");
  config.IMG_TOPFILTREPLAYER =
    config.IMG_BASE + "players/playerfiltertop/S_{{playerId}}.png";
  config.IMG_HELP = config.IMG_BASE + "helpImage/{{imgName}}.png";
  config.URL_BASE = config.BASE_DOMAIN;
  config.ACCOUNTS_API_BASE = config.BASE_DOMAIN + "quiz/services/";
  config.CONTEST_API_BASE = config.ACCOUNTS_API_BASE;
  config.LEADERBOARD_API_BASE = "services/Leaderboard/";
  config.generateImagePath =
    config.API_BASE + "services/image/{guid}/{lang}/generate?download={bool}";
  config.sDomain = ".sportz.io";
  config.GA_TRACKING_ID = window.GA_TRACKING_ID
    ? window.GA_TRACKING_ID
    : "UA-233182980-1";
  config.CAPTCHA_KEY = "6LcNRsQaAAAAAJqwOH5MmH2-Ul-zQnZ4afY4orv0";
} else if (location.indexOf(":300") > -1) {
  config.API_BASE = config.BASE_DOMAIN;
  config.IMG_BASE = config.BASE_DOMAIN + "images/";
  config.IMG_TEAM = config.IMG_BASE + "flags/{{teamId}}.png";
  config.IMG_CONTEST_LOGO = config.IMG_BASE + "contestLogos/{{imgName}}_3x.png";
  config.DefaultFlagImagesURL = config.IMG_TEAM.replace(
    "{{teamId}}",
    "Default"
  );
  config.IMG_PITCH = config.IMG_BASE + "players/onpitch/{{playerId}}.png";
  config.IMG_CARD = config.IMG_PITCH;
  config.IMG_TOPFILTREPLAYER =
    config.IMG_BASE + "players/playerfiltertop/S_{{playerId}}.png";
  config.IMG_HELP = config.IMG_BASE + "helpImage/{{imgName}}.png";
  config.URL_BASE = "/";
  config.ACCOUNTS_API_BASE = config.BASE_DOMAIN + "services/api/";
  config.CONTEST_API_BASE = config.ACCOUNTS_API_BASE + "ManageContest/";
  config.LEADERBOARD_API_BASE = config.ACCOUNTS_API_BASE + "Leaderboard/";
  config.sDomain = "dream11-loadtest-demo.sportz.io";
} else {
  config.BASE_DOMAIN = "/";
  config.API_BASE = config.BASE_DOMAIN;
  config.IMG_BASE = config.BASE_DOMAIN + "static-assets/quiz/build/images/";
  config.IMG_TEAM = config.IMG_BASE + "flags/{{teamId}}.png";
  config.IMG_OVERLAY_TEAM = config.IMG_BASE + "flags/overlay/{{teamId}}.png";
  config.IMG_CONTEST_LOGO = config.IMG_BASE + "contestLogos/{{imgName}}.png";
  config.DefaultFlagImagesURL = config.IMG_TEAM.replace("{TeamId}", "Default");
  config.IMG_PITCH = config.IMG_BASE + "players/onpitch/{{playerId}}.png";
  config.IMG_CARD = config.IMG_PITCH;
  config.DEFAULT_IMG_CARD = config.IMG_CARD.replace("{{playerId}}", "default");
  config.IMG_TOPFILTREPLAYER =
    config.IMG_BASE + "players/playerfiltertop/S_{{playerId}}.png";
  config.IMG_HELP = config.IMG_BASE + "helpImage/{{imgName}}.png";
  config.URL_BASE = config.BASE_DOMAIN;
  config.ACCOUNTS_API_BASE = config.BASE_DOMAIN + "quiz/services/";
  config.CONTEST_API_BASE = config.ACCOUNTS_API_BASE;
  config.LEADERBOARD_API_BASE = config.ACCOUNTS_API_BASE;
  config.generateImagePath =
    config.API_BASE + "services/image/{guid}/{lang}/generate?download={bool}";
  config.sDomain = window.location.hostname; //"dream11-login.sportz.io";
  config.GA_TRACKING_ID = window.GA_TRACKING_ID
    ? window.GA_TRACKING_ID
    : "UA-233182980-2";
  config.CAPTCHA_KEY = "6LcxpPYUAAAAADxGLEHwkbPz8jmNhCkqLHhsZkXh";
  config.COOKIE_FANTASY = "fihquiz_SRAW";
}

config.serverApiUrl = "https://time.akamai.com/?iso";
config.IS_MOBILE = window.outerWidth < 768;
config.IS_TABLET = window.outerWidth <= 768;

config.playerEmptyValue = 1;
config.emptyValue = 0;
config.unAuthorizeUserRetval = -999;

config.Platform = { web: 1 };
config.redirectLogin =
  window.location.protocol +
  "//" +
  window.location.host +
  "/" + // config.BASE_DOMAIN +
  `login?ru={{replace}}`;
config.redirectFavTeam =
  window.location.protocol +
  "//" +
  window.location.host +
  "/" + // config.BASE_DOMAIN +
  `quick-check-detailed?ru={{replace}}`;
config.redirectLogout =
  window.location.protocol +
  "//" +
  window.location.host +
  config.ACCOUNTS_API_BASE +
  "Session/user/sso/logout";

config.playerImageUrl = "";
config.formationImageUrl = "";
config.jerseyImageUrl = "";
config.gkJerseyImageUrl = "";
/*---leagues---*/
config.MaxLeaderBoardMembers = 1000;
config.noOfItemFirstPage = 5;
config.noOfItemAddOnPage = 5;
config.maxlength = "20";

/*---leaderboard---*/
config.leaderboardPageOneChunk = 10;
config.leaderboardAddOnPageChunk = 10;

config.shreGenerateImage =
  config.ACCOUNTS_API_BASE + "Share/user/{{guid}}/{{gamedayid}}/generate";
config.dwnGenerateImage =
  config.ACCOUNTS_API_BASE +
  "Share/user/{{guid}}/{{gamedayid}}/download?phaseId={{phaseId}}&scenario={{scenario}}&LangCode={{LangCode}}&backdoor=shaktiman";
config.shreGenerateImageResult = config.ACCOUNTS_API_BASE + "Unviel/share";
config.dwnGenerateImageResult =
  config.ACCOUNTS_API_BASE +
  "Unviel/download?formationId={{formationId}}&backdoor=shaktiman";
config.BrowserDetect = {
  Android: function () {
    return !!navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return !!navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  iPAD: function () {
    return !!navigator.userAgent.match(/iPad/i);
  },
  Windows: function () {
    return !!navigator.userAgent.match(/IEMobile/i);
  },
  Windows_surface: function () {
    return !(
      !navigator.userAgent.match(/Trident/i) ||
      !navigator.userAgent.match(/Tablet/i)
    );
  },
  any: function () {
    return (
      config.BrowserDetect.Android() ||
      config.BrowserDetect.BlackBerry() ||
      config.BrowserDetect.iOS() ||
      config.BrowserDetect.Windows()
    );
  },
  ie9: function () {
    return !!navigator.userAgent.match(/MSIE 9.0/i);
  },
  ie10: function () {
    return !!navigator.userAgent.match(/MSIE 10.0/i);
  },
  ie: function () {
    return !(
      !navigator.userAgent.match(/MSIE/i) &&
      !navigator.userAgent.match(/Trident/i)
    );
  },
  FF: function () {
    return "undefined" != typeof InstallTrigger;
  },
  safari: function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") != -1) {
      if (ua.indexOf("crios") > -1) {
        return false; // Chrome
      } else {
        return true; // Safari
      }
    }
    // return !!navigator.userAgent.match(/Safari/i)
  },
};
config.enumGameMode = {
  live: 0,
  maintenance: 1,
  comingSoon: 2,
};
config.enumGameStatus = {
  open: 1,
  locked: 2,
  finished: 3,
};
config.enumEotScenarios = {
  no_eot: 1,
  logged_out_user: 2,
  logged_in_without_team: 3,
  logged_in_with_team: 4,
  logged_in_with_live_team: 5,
};
config.isAnnouncedStatus = {
  tour_not_started: 0,
  tour_started: 1,
  tour_last_match_live: 2,
  tour_ended: 3,
};

config.enumStaticUrls = {
  home: config.BASE_DOMAIN + "home",
  leaderboard: config.BASE_DOMAIN + "leaderboard",
  answers: config.BASE_DOMAIN + "answers",
  rules: config.BASE_DOMAIN + "rules",
  prizes: config.BASE_DOMAIN + "prizes",
  terms: config.BASE_DOMAIN + "terms",
};

config.timeoutForToast = 3000;
config.RhsCloseAnimationTimeout = 350;
config.hideScorecardAnimationTimeout = 150;
config.scrollTop = 45;
config.redirectDefault = `${config.URL_BASE}home`;
config.cookie = {
  gdprCookie: "GDPR_ACCEPT",
  loginSaveCookie: "LOGIN_SAVE",
};
config.enumBusters = {
  team: "TEAM_BUSTER",
  publicContest: "PUBLIC_LEAGUE_BUSTER",
  privateContest: "PRIVATE_LEAGUE_BUSTER",
  autorefresh: "autorefresh",
};

config.BUSTER = Date.now();

config.enumPosition = {
  all: -1,
  bat: 1,
  bowl: 2,
  ar: 3,
  wk: 4,
};
config.enumMode = {
  open: 1,
  switch: 2,
};
config.enumPositionText = {};
config.enumPositionText[config.enumPosition.bat] = "batsmen"; //(window.TRANS && window.TRANS.goalkeeper ? window.TRANS.goalkeeper : 'Goalkeeper');
config.enumPositionText[config.enumPosition.bowl] = "bowlers"; //(window.TRANS && window.TRANS.defender ? window.TRANS.defender : 'Defender');
config.enumPositionText[config.enumPosition.ar] = "allRounders"; //(window.TRANS && window.TRANS.midfielder ? window.TRANS.midfielder : 'Midfielder');
config.enumPositionText[config.enumPosition.wk] = "wicketKeepers";
config.enumPositionMinText = {};
config.enumPositionMinText[config.enumPosition.bat] = "batsman"; //(window.TRANS && window.TRANS.goalkeeper ? window.TRANS.goalkeeper : 'Goalkeeper');
config.enumPositionMinText[config.enumPosition.bowl] = "bowler"; //(window.TRANS && window.TRANS.defender ? window.TRANS.defender : 'Defender');
config.enumPositionMinText[config.enumPosition.ar] = "allRounder"; //(window.TRANS && window.TRANS.midfielder ? window.TRANS.midfielder : 'Midfielder');
config.enumPositionMinText[config.enumPosition.wk] = "wicketKeeper";

config.tempSelectedPlayerCookieName = "drm11-tempSelectedPlayerCookie";
config.tempTeamGamedayId = "drm11-tempTeamGamedayId";
config.formationId = "si-formationId";
config.redirectToRegister = "https://login.laczynaspilka.pl";
config.redirectToLogin = "/login?cid=customauth";

config.enumEventPage = {
  playNow: {
    action: "play_now",
    category: "Home",
    label: "Play Now",
  },
  continue: {
    action: "continue",
    category: "Home",
    label: "Continue",
  },
  viewLeaderbaord: {
    action: "view_leaderboard",
    category: "Home",
    label: "View Leaderboard",
  },
  backBtn: {
    action: "back_btn",
    category: "Gameplay",
    label: "Back Button on Gameplay",
  },
  fifty_fifty: {
    action: "50-50",
    category: "Gameplay",
    label: "50-50 Lifeline",
  },
  reveiw: {
    action: "review",
    category: "Gameplay",
    label: "Review Lifeline",
  },
  info: {
    action: "info",
    category: "Gameplay",
    label: "Info Icon on Gameplay",
  },
  submit_score: {
    action: "submit",
    category: "Gameplay",
    label: "Submit Score",
  },
  submit_new_user: {
    action: "submitNewUser",
    category: "Gameplay",
    label: "Submit New User",
  },
};

config.enumAnalyticsPages = {
  home: {
    sTitle: "Home",
    sPath: "/home",
  },
  scorecard: {
    sTitle: "Scorecard",
    sPath: "/home",
  },
  rules: {
    sTitle: "Rules",
    sPath: "/rules",
  },
  answers: {
    sTitle: "Answers",
    sPath: "/answers",
  },
  terms: {
    sTitle: "Terms",
    sPath: "/terms",
  },
  gameplay: {
    sTitle: "Gameplay",
    sPath: "/home",
  },
  leaderboard: {
    sTitle: "Leaderboard",
    sPath: "/leaderboard",
  },
};

config.enumFixtureType = {
  isUpcomming: 1,
  isLock: 2,
  isLive: 3,
  isFinished: 4,
  isAbandoned: 5,
  isEnded: 6,
  isOpen: 7,
};
config.enumTabsId = {
  teams: 1,
  matches: 2,
  nationality: 3,
  creditRange: 4,
};
config.enumNationalityIds = {
  foreign: 1,
  indian: 2,
};
config.enumRenderPlayerType = {
  listing: 1,
  search: 2,
  captain: 3,
};
config.enumMaxPositionNos = {};
config.enumMaxPositionNos[config.enumPosition.wk] = 1;
config.enumMaxPositionNos[config.enumPosition.bat] = 5;
config.enumMaxPositionNos[config.enumPosition.bowl] = 5;
config.enumMaxPositionNos[config.enumPosition.ar] = 3;

config.enumMinPositionNos = {};
config.enumMinPositionNos[config.enumPosition.wk] = 1;
config.enumMinPositionNos[config.enumPosition.bat] = 3;
config.enumMinPositionNos[config.enumPosition.bowl] = 3;
config.enumMinPositionNos[config.enumPosition.ar] = 1;
config.enumMinMaxType = { min: 1, max: 2 };
config.enumSwitchType = { none: 0, changeSource: 1, changeTarget: 2 };
config.jMaxForeignLimit = 4;
config.enumTeamRenderType = {
  normal: 1,
  captain: 2,
  favTeam: 3,
  playerInOut: 4,
  contest: 5,
  leaderboard: 6,
  overall: 7,
};
config.enumContestRenderType = {
  contest_listing: 1,
  contest_view: 2,
  contest_create: 3,
  contest_join: 4,
  contest_success_create: 5,
  contest_success_join: 6,
  contest_my_team: 7,
  contest_player_stats: 8,
  contest_view_leaderboard: 9,
  contest_view_player_stats: 10,
};
config.contestUrlPages = {
  default: {
    url: "/",
    viewId: config.enumContestRenderType.contest_listing,
  },
  myteam: {
    url: "/myteam",
    viewId: config.enumContestRenderType.contest_my_team,
  },
  playerstats: {
    url: "/playerstats",
    viewId: config.enumContestRenderType.contest_player_stats,
  },
  create: {
    url: "/create",
    viewId: config.enumContestRenderType.contest_create,
    blockInEot: true,
  },
  join: {
    url: "/join",
    viewId: config.enumContestRenderType.contest_join,
    allowDeepLinking: true,
    blockInEot: true,
  },
  view: {
    url: "/view",
    viewId: config.enumContestRenderType.contest_view,
    verifyLeague: true,
  },
};
config.enumSkillShortName = {};
config.enumSkillShortName[config.enumPosition.wk] = "WK";
config.enumSkillShortName[config.enumPosition.bat] = "BAT";
config.enumSkillShortName[config.enumPosition.bowl] = "BOWL";
config.enumSkillShortName[config.enumPosition.ar] = "AR";
config.enumSortingOrder = {};
config.enumSortingOrder[config.enumPosition.wk] = 4;
config.enumSortingOrder[config.enumPosition.bat] = 3;
config.enumSortingOrder[config.enumPosition.ar] = 2;
config.enumSortingOrder[config.enumPosition.bowl] = 1;
config.enumScrollPosition = {
  up: "up",
  down: "down",
};
config.statsCategory = {
  points: 1,
  percentSelected: 2,
  percentCaptain: 3,
  percentViceCaptain: 4,
};
config.statsTab = [
  {
    key: 1,
    name: "points",
    value: "gdpoint",
  },
  {
    key: 2,
    name: "percent_select",
    value: "sper",
  },
  {
    key: 3,
    name: "percent_c",
    value: "csper",
  },
  {
    key: 4,
    name: "percent_vc",
    value: "vcsper",
  },
];
config.leaderboardApiParams = {
  optType: 1,
  recordsPerPage: 100,
  liveRecPerPagePublic: 100,
  liveRecPerPagePrivate: 500,
};
config.publicLeagueIds = {
  global: 1,
  favTeam: 2,
};
config.enumBonus = { captain: 2, viceCaptain: 1.5 };
config.gameplay = [
  {
    key: 1,
    icon: "gameplay1.svg",
    heading: "gameplay1_heading",
    description: "gameplay1_desc",
  },
  {
    key: 2,
    icon: "gameplay2.svg",
    heading: "gameplay2_heading",
    description: "gameplay2_desc",
  },
  {
    key: 3,
    icon: "gameplay3.svg",
    heading: "gameplay3_heading",
    description: "gameplay3_desc",
  },
  {
    key: 4,
    icon: "gameplay4.svg",
    heading: "gameplay4_heading",
    description: "gameplay4_desc",
  },
  {
    key: 5,
    icon: "gameplay5.svg",
    heading: "gameplay5_heading",
    description: "gameplay5_desc",
  },
];
config.howtoplay = [
  {
    key: 1,
    rule: "rule1",
  },
  {
    key: 2,
    rule: "rule2",
  },
  {
    key: 3,
    rule: "rule3",
  },
];

config.enumTrend = {
  3: {
    class: "si-up",
  },
  1: {
    class: "si-tie",
  },
  2: {
    class: "si-down",
  },
};

config.zIndClass = "si-zindex--high";

config.topUsers = 1;
config.topPerformance = 2;
config.topSelected = 3;
config.moreLink = {
  // myProfile: ('https://fantasy.iplt20.com/userprofile?ru=' + config.URL_BASE + config.enumStaticUrls.more),
  myProfile:
    window.location.origin +
    "/userprofile?ru=" +
    config.URL_BASE +
    config.enumStaticUrls.more,

  privacyPolicy: "https://www.fih.hockey/privacy-policy",
  termsAndCondition: "https://fantasy.iplt20.com/ipl/termsandconditions",
};

config.favTeamQueryString = "?hasfavteam=1";
config.enumErrorCode = { normal: 0, isToast: 1, isRedirect: 2 };

config.quizTimer = 20;
config.timeoutForAnswerReveal = 3000;
config.toastTime = 3000;
config.GAMEPLAY_API_BASE_PATH = config.ACCOUNTS_API_BASE + "Gameplay/";
config.TUTORIAL_API = config.ACCOUNTS_API_BASE + "Feed/tutorial";
config.TRANSLATION_API = config.ACCOUNTS_API_BASE + "Feed/translations";
config.COUNTRIES_API = config.ACCOUNTS_API_BASE + "Feed/country";
config.AGE_GROUP_API = config.ACCOUNTS_API_BASE + "Feed/agegroup";
config.REGISTER_USER_API = config.ACCOUNTS_API_BASE + "Session/registration";
config.GAMEDAY_API = config.ACCOUNTS_API_BASE + "Leaderboard/getgameday";
config.ANSWERS_API = config.ACCOUNTS_API_BASE + "Feed/gamedayquestionanswer";

config.Platform = { web: 1 };
config.QuestionType = {
  E: config.trans && config.trans.easy ? config.trans.easy : "EASY",
  M: config.trans && config.trans.medium ? config.trans.medium : "MEDIUM",
  H: config.trans && config.trans.hard ? config.trans.hard : "TOUGH",
};

export default config;
